/**
 * Custom App Categories Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { customAppCategoriesService } from '../../services';
import { notify } from '../../shared/services';
import type {
  CreateUserCustomAppCategoryDto,
  UpdateUserCustomAppCategoryDto,
} from '../../types';
import { queryKeys } from './queryKeys';

export const useMyCategories = () => {
  return useQuery({
    queryKey: queryKeys.customAppCategories.myCategories(),
    queryFn: () => customAppCategoriesService.getMyCategories(),
  });
};

export const useCreateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateUserCustomAppCategoryDto) => customAppCategoriesService.create(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.customAppCategories.all });
    },
  });
};

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateUserCustomAppCategoryDto }) =>
      customAppCategoriesService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.customAppCategories.all });
    },
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => customAppCategoriesService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.customAppCategories.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.customApps.all });
      notify.success('Category deleted');
    },
  });
};
